import { render } from "./FullScreenLoader.vue?vue&type=template&id=2d23d1ea"
import script from "./FullScreenLoader.vue?vue&type=script&lang=js"
export * from "./FullScreenLoader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__